export default class DonationProductQuestionAlternatives {

    constructor() {
        this.id = 0;
        this.description = "";
    }
}